/* Vanshitaaz founder image-with-text — Instagram-style "… more / less"
   for the bio on mobile. Clamps to 3 lines (CSS) and toggles on tap;
   the button auto-hides when the text already fits, and on desktop. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  function setup(wrap) {
    if (wrap.dataset.iwtMore === 'done') return;
    wrap.dataset.iwtMore = 'done';

    // clamp the first paragraph (line-clamp doesn't truncate a nested block);
    // any further paragraphs are hidden entirely until expanded, so the
    // more/less toggle hides the whole bio, not just its first paragraph.
    var paragraphs = wrap.querySelectorAll('p');
    var bio = paragraphs[0] || wrap;
    var extra = Array.prototype.slice.call(paragraphs, 1);
    bio.classList.add('iwt-founder-bio', 'clamped');
    extra.forEach(function (p) { p.classList.add('iwt-founder-extra'); });

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'iwt-founder-more';
    btn.textContent = '… more';
    wrap.insertAdjacentElement('afterend', btn);

    btn.addEventListener('click', function () {
      var clamped = bio.classList.toggle('clamped');
      wrap.classList.toggle('iwt-founder-expanded', !clamped);
      btn.textContent = clamped ? '… more' : 'less';
    });

    function sync() {
      // Only relevant on mobile; on desktop CSS shows full text + hides btn.
      if (!window.matchMedia(MOBILE).matches) return;
      // If not currently expanded, check whether the clamp actually truncates
      // (or there are hidden extra paragraphs) — either way, show the toggle.
      if (bio.classList.contains('clamped')) {
        var overflowing = bio.scrollHeight > bio.clientHeight + 2 || extra.length > 0;
        btn.style.display = overflowing ? 'inline-block' : 'none';
      }
    }
    sync();
    window.addEventListener('resize', sync);
  }

  function init() {
    document
      .querySelectorAll('.image-with-text--vz-founder .image-with-text__text.rte')
      .forEach(setup);
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();
